import { ComponentProps } from 'react'

import { Icon } from '@podo-app/design-system-temp'

const CreditCardIcon = (props: ComponentProps<typeof Icon>) => {
  return (
    <Icon width="25" height="24" viewBox="0 0 25 24" fill="none" stroke="none" {...props}>
      <rect x="2.5" y="5.75" width="20.5" height="12.5" rx="1.25" stroke="black" strokeWidth="1.5" />
      <rect x="1.75" y="8" width="22" height="2.5" fill="black" />
      <circle cx="5.75" cy="15.5" r="1" fill="black" />
    </Icon>
  )
}

export default CreditCardIcon
